import { watch, ref, Ref } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import createHandler from '@/renderer/components/SpacePage/compositions/createHandler';
import { SMH } from '@/renderer/scripts/smh';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default (spaceId: Ref<SMH.SpaceId>) => {
  const { methods: createMethods } = createHandler(spaceId);
  const NEW_FOLDER_DEFAULT_NAME = i18n_t('新建文件夹');
  const newFolderName = ref(NEW_FOLDER_DEFAULT_NAME);
  const isShowNewFolder = ref(false);
  const isShowNewFolderErrorTips = ref(false);
  const newFolderErrorTips = ref('');
  watch(
    () => isShowNewFolder.value,
    () => {
      newFolderName.value = NEW_FOLDER_DEFAULT_NAME;
      isShowNewFolderErrorTips.value = false;
    },
  );
  const handeleCreateNewFolder = async (dirPath: string[], cb?: Function) => {
    const name = newFolderName.value;
    if (name.trim() === '') {
      newFolderErrorTips.value = i18n_t('名称不能为空');
      isShowNewFolderErrorTips.value = true;
    } else if (name.indexOf('/') !== -1) {
      newFolderErrorTips.value = i18n_t('名称不支持字符“/”');
      isShowNewFolderErrorTips.value = true;
    } else if (name.length > 200) {
      newFolderErrorTips.value = i18n_t('名称不能超过200个字符');
      isShowNewFolderErrorTips.value = true;
    } else {
      newFolderErrorTips.value = '';
      isShowNewFolder.value = false;
      await createMethods.onCreateFolder(name, dirPath);
      cb && cb();
    }
  };
  return {
    newFolderName,
    isShowNewFolder,
    handeleCreateNewFolder,
    isShowNewFolderErrorTips,
    newFolderErrorTips,
  };
};
